"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
require("./InfoTooltip.scss");
class InfoTooltip {
  constructor(parent, container) {
    let position = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : 'title';
    let margins = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : {};
    let isFootnote = arguments.length > 4 && arguments[4] !== undefined ? arguments[4] : false;
    this.margins = {
      left: 0,
      right: 0,
      top: 0,
      bottom: 0,
      ...margins
    };
    const width = parent.node().offsetWidth;
    this.container = container;
    this.grandparent = parent;
    this.parent = parent.append('div').classed('info-wrapper', true).classed('chart-info', position === 'chart');
    this.parent.append('div').classed('info-icon', true).classed('footnote', isFootnote);
    this.tooltip = this.parent.append('div').classed('info-tooltip', true).style('max-width', `${width}px`);
    const content = this.tooltip.append('div').classed('info-content', true);
    content.append('div').classed('info-title', true);
    content.append('div').classed('info-body', true);
    let offset = '0px';
    if (position === 'chart') {
      offset = '-12px';
    }
    this.parent.style('margin-left', `calc(${this.margins.left} + ${offset})`).style('margin-right', `calc(${this.margins.right}`).style('margin-top', `calc(${this.margins.top} + ${offset})`).style('margin-bottom', `calc(${this.margins.bottom})`);
  }
  static inChart(container, _ref) {
    let {
      info
    } = _ref;
    const infoContainer = container.select('.info-wrapper');
    if (infoContainer.empty()) {
      new InfoTooltip(container, container, 'chart', {
        left: '98%',
        top: '2%'
      }, info.isFootnote).onHover(info);
    }
  }
  onHover(_ref2) {
    let {
      title,
      content
    } = _ref2;
    return this.parent.on('mousemove', () => {
      this.draw({
        title,
        content
      });
    }, {
      passive: true
    }).on('mouseout', () => {
      this.hide();
    }, {
      passive: true
    });
  }
  draw(_ref3) {
    let {
      title,
      content
    } = _ref3;
    let yOffset = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 4;
    const bubbleBox = this.parent.select('.info-icon').node().getBoundingClientRect();
    const tooltipBox = this.tooltip.node().getBoundingClientRect();
    const containerBox = this.container.node().getBoundingClientRect();
    const targetLeft = bubbleBox.width;
    let targetTop = -tooltipBox.height - bubbleBox.height - yOffset;
    if (bubbleBox.top + targetTop < containerBox.top) {
      targetTop = yOffset;
    }
    this.tooltip.style('transform', `translate(${targetLeft}px, ${targetTop}px)`);
    this.container.select('div.info-content').style('transform', `translateX(${Math.min(0, containerBox.right - tooltipBox.right)}px)`);
    this.tooltip.select('div.info-title').text(title);
    this.tooltip.select('div.info-body').text(content);
    this.show();
  }
  show() {
    this.tooltip.classed('show', true);
    this.grandparent.style('z-index', 2);
  }
  hide() {
    this.tooltip.classed('show', false);
    this.grandparent.style('z-index', 1);
  }
}
exports.default = InfoTooltip;